/* eslint-disable react-hooks/rules-of-hooks */

import { memberAuthorize } from 'core/api/sitecore.api';
import { usePostMock } from 'core/api/mocks';
import { smartMockApi } from 'core/api';

import { useGetTalSsoToken } from 'core/api/client/InsuranceApi';

import GetTalSsoToken from './mocks/GetTalSsoToken.mock.json';

export default smartMockApi({
	memberAuthorize: {
		live: memberAuthorize,
		mock: () => {
			return new Promise(res => {
				setTimeout(() => {
					res({
						status: 200,
						data: { isValid: true },
					});
				}, 500);
			});
		},
	},
	useGetTalSsoToken: {
		live: useGetTalSsoToken,
		mock: () => {
			return usePostMock({ payload: GetTalSsoToken });
		},
	},
});
